import { useMutation } from "react-query";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deleteDepartment = ({ departmentId }: { departmentId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/Departments/DeleteDepartment/${departmentId}`);
};

type QueryFnType = typeof deleteDepartment;

type UseDeleteDepartmentOptions = {
  departmentId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteDepartment = ({ config }: UseDeleteDepartmentOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: any) => {
      addNotification(`Υπήρξε κάποιο πρόβλημα στην διαγραφή της Διεύθυνσης.`, 500);
      console.error("Couldnt delete Department", error);
      setIsNotificationVisible(true);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllDepartments"]);
      addNotification(`Η Διεύθυνση Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deleteDepartment,
  });
};
